<div id="table_events" class="tablewrap resizetable tabpage">
    <div class="table tableevents">
        <table fixedcols="[0]" id="eventslist">
            <tr>
              <th *ngIf="trackingMode" class="checkboxrow"><input type="checkbox"/></th>
              <th class="object_column">{{'Object'|translate }}</th>
              <th class="datetime_column">{{'Fire time'|translate }}</th>
              <th class="datetime_column">{{'Revoke time'|translate }}</th>
              <th>{{'Message'|translate }}</th>
            </tr>
        </table>
    </div>
    <app-pagination [viewmode]="'print excel'" [printElementID]="'eventslist'"></app-pagination>
</div>
